import { memo, useState } from "react";

import { Popover } from "antd";

import { useChartEntities } from "hooks/charts";

import { GroupBy as GroupByIcon } from "components/icons";

import { EvaChart } from "../../../../constants/charts.enums";
import { useChartsContext } from "../../../../contexts/ChartContext";
import ToolbarButton from "../../../base/ToolbarButton";
import ChartFocusSettings from "./ChartFocusSettings";

const ChartFocusToggle = () => {
  const { id } = useChartsContext();
  const { chartFocus, chartType } = useChartEntities(id);
  const isActive = chartFocus?.active;
  const showButton = chartFocus?.show;
  const isEnabled = chartFocus?.enabled ?? true;
  const [visible, setVisible] = useState(false);

  if (!showButton) {
    return null;
  }
  const getChartFocusText = () => {
    switch (chartType) {
      case EvaChart.WellContribution:
        return "Upstream Selected Field";
      default:
        return "Chart Focus";
    }
  };
  return (
    <Popover
      placement="bottomRight"
      arrowPointAtCenter
      content={<ChartFocusSettings />}
      trigger="click"
      open={isEnabled && visible}
      onOpenChange={(v) => isEnabled && setVisible(v)}>
      <ToolbarButton
        data-testid={isActive ? "chartFocusToggleActive" : "chartFocusToggleInactive"}
        icon={<GroupByIcon size={18} />}
        isMenuButton={true}
        overflowLabel={getChartFocusText()}
        tooltipText={getChartFocusText()}
        active={isActive}
        disabled={!isEnabled}
      />
    </Popover>
  );
};

export default memo(ChartFocusToggle);
